module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "RunningSheetHistory"
    }
  }, [_c('modal', {
    attrs: {
      "transition": "modal fade",
      "title": _vm.modalTitle,
      "large": "",
      "force": ""
    },
    on: {
      "ok": function($event) {
        return _vm.ok()
      },
      "cancel": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', [_c('datatable', {
    ref: "running_sheet_hist_instance",
    attrs: {
      "id": "running-sheet-hist-instance",
      "dtOptions": _vm.dtOptionsRunningSheetHistory,
      "dtHeaders": _vm.dtHeadersRunningSheetHistory,
      "parentStyle": " "
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.errorResponse) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "white-space": "pre"
    }
  }, [_vm._v(_vm._s(_vm.errorResponse))])])])])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d21d0e62"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/internal/legal_case/running_sheet_history.vue
// module id = 1052
// module chunks = 0